import type {RouterConfig} from '@nuxt/schema'

export default {

// to: 目標路由的導航資訊。
// _from: 當前路由的導航資訊（目前沒有使用）。
// savedPosition: 當瀏覽器頁面刷新或重載時，如果存在保存的滾動位置，會返回這個位置。
/*    scrollBehavior: (to, _from, savedPosition) => {
        console.log('client', import.meta.client);
        console.log('isHydrating', useNuxtApp().isHydrating);
        console.log('window', window);
        if (to.hash) {
            return {
                el: to.hash, // 如果目標是帶有 hash（例如 #section），則滾動到該元素
                behavior: 'smooth' // 滾動行為為平滑
            }
        } else if (savedPosition) {
            return savedPosition; // 如果存在之前的滾動位置，則恢復至該位置
        } else {
            return {top: 0}; // 默認情況下，滾動到頁面頂部
        }
    }*/


}satisfies RouterConfig
